import ViewTable from "modules/DeclareLeave/components/CustomTable";

import {
  Autocomplete,
  Box,
  Button,
  Divider,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import pxToRem from "theme/base/pxToRem";

import { useDispatch, useSelector } from "react-redux";
import {
  dataConfirmSelector,
  listEmployeeOfManagerSelector,
  listTimeKeepingManagerSelector,
  rangeTimeKeepingSelector,
  timeConfirmPeriodSelector,
} from "modules/DeclareLeave/redux/selector";

import EmptyState from "components/common/EmptyState";
// import ArriveLateManagerDetails from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/components/Modals/ArriveLateManagerDetail";
import { Header, TimeKeepingWrapper } from "./styles";
import { Wrapper } from "components/common/Form/FormSelect/style";
import useColumns from "./useColumn";
import { useEffect, useState } from "react";

import {
  getListTimeKeepingManagerStart,
  resetListTimeKeepingManager,
} from "modules/DeclareLeave/redux/getListTimeKeepingManager";

import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { ReactComponent as IconArrowHeadDown } from "assets/svg/20-arrowhead-down.svg";

import {
  formFilterTimeKeepingManagerReset,
  formFilterTimeKeepingManagerUpdate,
} from "modules/DeclareLeave/redux/formFilterTimeKeepingManager";
import {
  confirmTimeKeepingStart,
  setDataConfirmTimeKeeping,
} from "modules/DeclareLeave/redux/confirmTimeKeeping";
import { exportTimeKeepingManagerStart } from "modules/DeclareLeave/redux/exportTimeKeepingManager";
import { STATUS_CONFIRM } from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/const";

import { ReactComponent as IconDownload } from "assets/svg/20-download.svg";
import ModalTimekeepingDetail from "./modal/ModalTimekeepingDetail";
import { DIALOG } from "helper/enum/dialogEnum";
import { useDialog } from "helper/customHook";
import { getTimeKeepingManagerDetailStart } from "modules/DeclareLeave/redux/getTimeKeepingManagerDetail";
import {
  getRangeTimeKeepingStart,
  resetGetRangeTimeKeeping,
} from "modules/DeclareLeave/redux/getRangeTimeKeeping";
import { ReactComponent as IconChevronDown } from "assets/svg/chevron_down.svg";
import { getEmployeeOfManagerStart } from "modules/DeclareLeave/redux/getEmployeeOfManager";
import { SCREEN } from "helper/roleChecker/Screens";
import {
  getTimeConfirmPeriodStart,
  resetGetTimeConfirmPeriod,
} from "modules/DeclareLeave/redux/getTimeConfirmPeriod";

const locale = "vi";

export const statusOptions = [
  { label: "Chưa xác nhận", value: STATUS_CONFIRM.PENDING },
  { label: "Đã xác nhận", value: STATUS_CONFIRM.APPROVE },
  { label: "Tự động xác nhận", value: STATUS_CONFIRM.AUTO_APPROVE },
  { label: "Chờ gửi", value: STATUS_CONFIRM.WAITING_REQUEST },
];

export const TimeKeepingManagement = () => {
  const timekeepingDetailDialog = useDialog(DIALOG.TIMEKEEPING_DETAIL_MANAGER);
  const data = useSelector(listTimeKeepingManagerSelector);
  const timeKeepingData = useSelector(rangeTimeKeepingSelector);
  const listEmployeeOfManager = useSelector(listEmployeeOfManagerSelector);
  const { ids } = useSelector(dataConfirmSelector);
  const timeConfirm = useSelector(timeConfirmPeriodSelector);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const [monthSelected, setMonthSelected] = useState(moment());

  const { columns } = useColumns();

  const handleChangeMonth = (newValue) => {
    setMonthSelected(newValue);
    const timeSelected = {
      month: newValue.month() + 1,
      year: newValue.year(),
    };

    dispatch(
      formFilterTimeKeepingManagerUpdate({
        ...timeSelected,
      })
    );
    dispatch(
      getEmployeeOfManagerStart({
        ...timeSelected,
        screenCode: SCREEN.IP_019,
      })
    );

    dispatch(
      getTimeConfirmPeriodStart({
        ...timeSelected,
        screenCode: SCREEN.IP_019,
      })
    );
    dispatch(getRangeTimeKeepingStart(timeSelected));

    dispatch(
      setDataConfirmTimeKeeping({
        ...timeSelected,
      })
    );

    dispatch(resetListTimeKeepingManager());
    dispatch(getListTimeKeepingManagerStart());
  };

  const handleConfirm = () => {
    dispatch(
      confirmTimeKeepingStart({
        callback: () => {},
      })
    );
  };

  const handleSelect = (value) => {
    const ids = [];
    data?.forEach((it, idx) => {
      if (value[idx]) {
        ids.push(it?.employeeCode);
      }
    });

    dispatch(
      setDataConfirmTimeKeeping({
        ids,
      })
    );
  };

  useEffect(() => {
    dispatch(getListTimeKeepingManagerStart());
    const timeNow = {
      month: moment().month() + 1,
      year: moment().year(),
    };
    dispatch(getRangeTimeKeepingStart(timeNow));
    dispatch(
      getEmployeeOfManagerStart({
        ...timeNow,
        screenCode: SCREEN.IP_019,
      })
    );
    dispatch(
      getTimeConfirmPeriodStart({
        ...timeNow,
        screenCode: SCREEN.IP_019,
      })
    );
    return () => {
      dispatch(resetListTimeKeepingManager());
      dispatch(formFilterTimeKeepingManagerReset());
      dispatch(resetGetRangeTimeKeeping());
      dispatch(resetGetTimeConfirmPeriod());
    };
  }, []);

  const validateEnableRowSelection = (row) => {
    return row.original.status === STATUS_CONFIRM.PENDING; // Example: Disable selection if status is "inactive"
  };

  return (
    <TimeKeepingWrapper>
      <Header>
        <Box display={"flex"} alignItems={"center"} gap={1}>
          <Box display={"flex"} alignItems={"center"}>
            <Typography
              fontSize={18}
              fontWeight={600}
              onClick={() => setOpen(!open)}
            >
              Bảng tổng hợp chấm công{" "}
              {moment(timeKeepingData?.fromDate, "YYYY-MM-DD").format("DD/MM")}{" "}
              - {moment(timeKeepingData?.toDate, "YYYY-MM-DD").format("DD/MM")}
            </Typography>
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              adapterLocale={locale}
            >
              <DatePicker
                views={["month", "year"]}
                sx={(theme) => ({
                  fieldset: {
                    border: "none",
                  },
                  ".MuiInputBase-root.MuiOutlinedInput-root": {
                    paddingRight: pxToRem(4),
                    input: {
                      width: pxToRem(10),
                      textTransform: "capitalize",
                      color: theme.palette.text.textPrimary,
                      cursor: "pointer",
                      padding: 0,
                      // display: "none",
                      opacity: 0,
                    },
                  },
                  ".MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
                    opacity: 0,
                    position: "absolute",
                    right: pxToRem(50),
                    button: {
                      width: pxToRem(140),
                      marginRight: `-${pxToRem(75)}`,
                    },
                  },
                })}
                value={monthSelected}
                format="MM - YYYY"
                onChange={handleChangeMonth}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                openTo="month"
                closeOnSelect={true}
                slots={{ actionBar: () => null }}
              />
            </LocalizationProvider>
          </Box>
          <IconButton
            sx={(theme) => ({
              svg: { path: { fill: theme.palette.icon.icPrimary } },
              // pointerEvents: "none",
            })}
            onClick={() => setOpen(!open)}
          >
            <IconArrowHeadDown />
          </IconButton>
        </Box>
        <Box display={"flex"} alignItems={"center"} gap={2} flexWrap={"wrap"}>
          <Wrapper
            variant="standard"
            sx={{
              width: pxToRem(300),
              li: {
                padding: pxToRem(16),
              },
            }}
            hasLabel={false}
          >
            <Autocomplete
              className="MuiSelect-select"
              id={"employeeCode"}
              options={listEmployeeOfManager}
              getOptionLabel={(option: any) => option.label}
              onChange={(event, newValue: any) => {
                dispatch(
                  formFilterTimeKeepingManagerUpdate({
                    employeeCode: newValue?.value,
                  })
                );

                dispatch(resetListTimeKeepingManager());
                dispatch(getListTimeKeepingManagerStart());
              }}
              popupIcon={
                <Box sx={{ padding: pxToRem(10) }}>
                  <IconChevronDown />
                </Box>
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={"Tìm nhân sự"}
                  variant="standard"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </Wrapper>
          <Wrapper
            variant="standard"
            sx={{
              width: pxToRem(300),
              li: {
                padding: pxToRem(16),
              },
            }}
            hasLabel={false}
          >
            <Autocomplete
              className="MuiSelect-select"
              id={"status"}
              options={statusOptions}
              getOptionLabel={(option: any) => option.label}
              onChange={(event, newValue: any) => {
                dispatch(
                  formFilterTimeKeepingManagerUpdate({
                    status: newValue?.value,
                  })
                );

                dispatch(resetListTimeKeepingManager());
                dispatch(getListTimeKeepingManagerStart());
              }}
              popupIcon={
                <Box sx={{ padding: pxToRem(10) }}>
                  <IconChevronDown />
                </Box>
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={"Trạng thái"}
                  variant="standard"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </Wrapper>
        </Box>
      </Header>
      <ViewTable
        isSelected={true}
        data={data ?? []}
        columns={columns}
        columnPinning={{
          left: [],
          right: ["totalWorkDays", "status"],
        }}
        handleFetchMore={() => {}}
        messageEmpty={
          <EmptyState
            message="Không có dữ liệu"
            sx={(theme) => ({
              h6: {
                color: theme.palette.text.textSecondary,
              },
            })}
          />
        }
        handleSelection={handleSelect}
        handleOnClickedRow={(item) => {
          dispatch(
            getTimeKeepingManagerDetailStart({
              employeeCode: item.employeeCode,
              month: monthSelected.month() + 1,
              year: monthSelected.year(),
            })
          );
          timekeepingDetailDialog.open();
        }}
        height={600}
        validateEnableRowSelection={validateEnableRowSelection}
      />
      <Divider />
      <Box display={"flex"} flexDirection={"column"} gap={2}>
        <Typography
          sx={(theme) => ({
            color: theme.palette.text.textSecondary,
            fontSize: 14,
          })}
        >
          Vui lòng xác nhận ngày công trong tháng (Từ ngày{" "}
          {moment(timeConfirm?.fromDate, "YYYY-MM-DD").date()} đến ngày{" "}
          {moment(timeConfirm?.toDate, "YYYY-MM-DD").date()} hàng tháng) để có
          cơ sở tính lương cho nhân sự của bạn
        </Typography>
        <Box display={"flex"} gap={2}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleConfirm}
            disabled={!ids?.length}
          >
            Gửi xác nhận ngày công
          </Button>
          <Button
            variant="outlined"
            color="primary"
            sx={{ width: pxToRem(162), fontWeight: "400" }}
            onClick={() => {
              dispatch(exportTimeKeepingManagerStart());
            }}
            // disabled={!data || !data.length}
          >
            Xuất Excel <IconDownload style={{ marginLeft: pxToRem(5) }} />
          </Button>
        </Box>
        <ModalTimekeepingDetail monthSelected={monthSelected} />
      </Box>
    </TimeKeepingWrapper>
  );
};
